import {BehaviorSubject} from 'rxjs';
import {commonContractSymbolStorage} from '@px/storage/contract-symbol';
import {QtyType} from '@px/enum/order';
import {wwData$} from './worker-data';

export const qtyTypeBeforeV2$ = new BehaviorSubject<QtyType>(initQtyType('Perpetual'));
export const qtyTypeV2$ = new BehaviorSubject<QtyType>(initQtyType('PerpetualV2'));

function initQtyType(type: Exclude<TradeType, 'Spot'>) {
  return commonContractSymbolStorage.readContractSymbolStorage(type).qtyType;
}

qtyTypeBeforeV2$.subscribe((qtyType) => {
  wwData$.next({type: 'qty-before-v2-change', qtyType});
  commonContractSymbolStorage.updateContractSymbolStorage('Perpetual', {qtyType});
});

qtyTypeV2$.subscribe((qtyType) => {
  wwData$.next({type: 'qty-v2-change', qtyType});
  commonContractSymbolStorage.updateContractSymbolStorage('PerpetualV2', {qtyType});
});
